import constate from "constate";
import { useState } from "react";

const useSideNav = () => {
  const [hideSideNav, setHideSideNav] = useState(true);

  return { actions: { setHideSideNav }, state: { hideSideNav } };
};

export const [SideNavProvider, useSideNavContext] = constate(useSideNav, (value) => value);
